import { ButtonNewRecord, FormCol, FormCol2, FormCol3 } from 'motion-components';
import React, { FC, ComponentProps } from 'react';
import { Button } from 'react-bootstrap';
import { FaPlus } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

type Props = ComponentProps<typeof Button> & { label; onClick };

export const ButtonNew: FC<Props> = (props) => {
  const { i18n, t } = useTranslation();
  return (
    <FormCol
      style={{
        maxHeight: '2rem',
        alignSelf: 'center',
        marginTop: '5px',
      }}
    >
      <ButtonNewRecord
        label={t(props.label)}
        onClick={props.onClick}
        size="sm"
        {...props}
        style={{ ...props.style }}
      />
    </FormCol>
  );
};
